import 'main';
import config from "config";
import core from "../app/core";
import * as bundle from 'bundle';
import UpdateDetails from 'portlets/parx-theme/update-details/updatedetails.model';

const dispatcher = bundle.dispatcher;

bundle.registerPortlets({
    'portlets_update_details_update_details_model': UpdateDetails
});

/**
 * Propagate configuration from React to Backbone.
 */
dispatcher.listen('app:config', (app) => {
    const detailsRecovery = {
        useEmailOnly: false,
        isRequiredVerificationEnable: false,
        enableSmsNotifications: false
    };

    config.load({ detailsRecovery, ...app });
    core.trigger('app:initialResourcesLoaded');
});
